<template>
  <div id="subscription-upgrade-yearly-monthly-card">
    <b-card
      v-if="apparatusesToAdd && apparatusesToAdd.length && subscriptionProduct"
      class="paid-subs-info-card mb-0 sub-card mx-1"
      body-class="subs-info-card-body"
      data-test-hook="existing-subscription-modal-paid-card"
    >
      <template #header>
        <div data-test-hook="subscription-upgrade-yearly-monthly-card-header" class="plan-header">
          {{ subscriptionProduct[0].name }}
        </div>
      </template>
      <b-row>
        <b-col>
          <b-button
            :variant="planChoice === 'yearly' ? 'primary' : 'secondary'"
            :class="getSplitButtonClass()"
            @click="planChoice = planChoice === 'yearly' ? 'monthly' : 'yearly'"
            data-test-hook="upgrade-to-multi-home-modal-button-continue"
          >
            <div v-if="planChoice === 'yearly'">
              <i class="far fa-check" />&nbsp;{{
                $t('xBilledAnnually')
              }}&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span style="color:black">&nbsp;{{ $t('xBilledMonthly') }}</span>
            </div>
            <div v-if="planChoice === 'monthly'">
              <span style="color:black">{{ $t('xBilledAnnually') }}</span>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <span style="color:white"><i class="far fa-check" />&nbsp;{{ $t('xBilledMonthly') }}</span>
            </div>
          </b-button>
        </b-col>
      </b-row>

      <div>
        <b-row v-if="planChoice === 'yearly'" class="align-items-center mb-2 mx-0 mt-3">
          <b-col class="col-0 px-0 text-center">
            <span class="mb-0 pb-0" data-test-hook="subscription-card-cost-yearly">
              <span class="price" style="font-size: 1.75rem;font-weight: bold">{{
                subscriptionProduct[1]?.cost | formatCurrency
              }}</span>
            </span>
            <span class="yearly ml-1" style="font-weight: bold">/{{ $t('xYear').toLowerCase() }}</span>
            &nbsp;<b-badge variant="primary" class="plan-badge text-right" style="vertical-align:super">{{
              $t('xSavePercent')
            }}</b-badge>
          </b-col>
        </b-row>

        <b-row v-if="planChoice === 'monthly'" class="align-items-center mb-2 mx-0 mt-3">
          <b-col class="col-0 px-0 text-center">
            <span class="mb-0 pb-0" data-test-hook="subscription-card-cost-yearly">
              <span class="price" style="font-size: 1.75rem;font-weight: bold">{{
                subscriptionProduct[0]?.cost | formatCurrency
              }}</span>
            </span>
            <span class="yearly ml-1" style="font-weight: bold">/{{ $t('xMonth').toLowerCase() }}</span>
          </b-col>
        </b-row>

        <b-row v-if="planChoice === 'monthlyold'" class="align-items-center mb-2 mx-0 mt-3">
          <b-col class="col-7 px-0 text-right">
            <div>
              <h1 class="mb-0 pb-0" data-test-hook="upgrade-subscription-card-cost">
                {{ subscriptionProduct[0]?.cost | formatCurrency }}
                <span class="monthly">/{{ $t('xMonth').toLowerCase() }}</span>
              </h1>
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="subscriptionCardText mt-3">
        <b-row>
          <b-col>
            <strong
              v-if="subscriptionProduct[0] && subscriptionProduct[0].description"
              data-test-hook="existing-subscription-modal-premium-monitoring-max-products-text"
            >
              {{ subscriptionProduct[0].description }}
            </strong>
          </b-col>
        </b-row>
        <b-row v-for="(apparatus, index) in apparatusesToUpgrade" :key="index">
          <b-col class="mt-2">
            <div class="d-flex">
              <i class="fas fa-fw fa-check-circle check-icon mr-2" />
              <p>{{ apparatus.name }}</p>
            </div>
          </b-col>
        </b-row>
        <b-row v-for="(apparatus, index) in apparatusesToAdd" :key="index">
          <ExpandableHsbSubscriptionFeaturesList
            v-if="apparatus.type === 0 || apparatus.apparatusType === 0"
            :id="`${apparatus.apparatusId}-${isNewPlan ? 'current' : 'new'}`"
            :generator-name="apparatus.name"
            :is-covered="isNewPlan"
          />
          <ExpandableTankSubscriptionFeaturesList
            v-else-if="apparatus.type === 2 || apparatus.apparatusType === 2"
            :id="`${apparatus.apparatusId}-${isNewPlan ? 'current' : 'new'}`"
            :tank-name="apparatus.name"
            :is-covered="isNewPlan"
          />
        </b-row>
      </div>
    </b-card>
  </div>
</template>

<script>
import * as Constants from '@/constants'

import ExpandableHsbSubscriptionFeaturesList from './ExpandableHsbSubscriptionFeaturesList.vue'
import ExpandableTankSubscriptionFeaturesList from './ExpandableTankSubscriptionFeaturesList.vue'

export default {
  props: ['subscriptionProduct', 'apparatusesToUpgrade', 'apparatusesToAdd', 'isNewPlan'],
  emits: ['setSelectedProduct'],

  computed: {
    savingsPercentage() {
      const annualizedMonthlyCost = this.subscriptionProduct[0]?.cost * 12
      const annualizedYearlyCost = this.subscriptionProduct[1]?.cost
      return Math.trunc(
        ((annualizedMonthlyCost - annualizedYearlyCost) /
          ((annualizedMonthlyCost + annualizedYearlyCost) / 2).toFixed(2)) *
          100
      )
    }
  },
  components: {
    ExpandableHsbSubscriptionFeaturesList,
    ExpandableTankSubscriptionFeaturesList
  },
  data() {
    return {
      planChoice: 'yearly'
    }
  },
  methods: {
    getSplitButtonClass() {
      if (this.planChoice === Constants.SubscriptionDurations.YEARLY) {
        return 'w-100 split-button-left-primary'
      } else {
        return 'w-100 split-button-right-primary'
      }
    },
    setSelectedProduct(product) {
      this.$emit('setSelectedProduct', product)
    }
  },
  watch: {
    planChoice() {
      this.setSelectedProduct(this.subscriptionProduct[this.planChoice === 'yearly' ? 1 : 0])
    }
  },
  mounted() {
    this.setSelectedProduct(this.subscriptionProduct[1]) //default to yearly, like on the screen
    this.planChoice = 'yearly'
  }
}
</script>
<style lang="scss">
#subscription-upgrade-yearly-monthly-card {
  h1 {
    font-weight: normal;
    line-height: 1.15;
  }

  .plan-details-header {
    font-size: 1.125em;
    line-height: 1.25;
    font-weight: 500;
  }

  .plan-header {
    text-align: center;
    padding: 5px 0px;
    font-size: 1.45em;
    line-height: 1.35;
    font-weight: 500;
  }

  .card-header {
    align-items: stretch;
    padding: 0;
    border-bottom: 0;
    height: 40px;
  }

  .sub-radio-dot {
    font-size: 0.875rem !important;
  }

  .paid-subs-info-card-new {
    &.current {
      border: 2px solid var(--carbon-300) !important;

      .plan-header {
        background-color: var(--carbon-300);
      }
    }

    &.new {
      border: 2px solid var(--brand-400) !important;

      .plan-header {
        background-color: var(--brand-400) !important;
      }
    }
  }

  .paid-subs-info-card {
    border: 2px solid var(--carbon-300) !important;
    padding: 0;
    border-radius: 8px;

    .plan-header {
      background-color: var(--carbon-300);
    }
  }

  .feature-list {
    strong {
      font-size: 14px;
    }
  }

  .card-title {
    margin-bottom: 0;
  }

  .cost-label {
    color: var(--carbon-900);
    font-size: 30px;
    font-weight: bold;
    border-color: var(--brand-600);
    border-width: 2px;
    margin-bottom: 10px;
  }

  .cadence-text {
    font-size: 16px !important;
  }

  .subs-info-card-body {
    padding: 15px 30px !important;
  }

  .split-button-left-primary {
    position: relative;
    display: inline-block;
    padding: 10px 20px;
    border: 2px solid #1a5690;
    color: white;
    font-size: 16px;
    cursor: pointer;
    background: linear-gradient(to right, #1a5690 50%, #f9fafa 50%);
  }
  .split-button-right-primary {
    position: relative;
    display: inline-block;
    padding: 10px 20px;
    border: 2px solid #1a5690;
    color: white;
    font-size: 16px;
    cursor: pointer;
    background: linear-gradient(to right, #f9fafa 50%, #1a5690 50%);
  }
}
</style>
